// AuthGuard.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem("company"); 

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/company/dashboard");
    }
  }, [isLoggedIn, navigate]);

  return !isLoggedIn ? children : null;
};

export default AuthGuard;
